import { Permission } from './permission.enum';

export class Role {
	id: number;
	organizationId: string;
	name: string;
	permissions: Permission[];
	isBuiltin?: boolean;
}
